import React from "react";
import { useSelector } from "react-redux";
import { Message } from "semantic-ui-react";

const Header = () => {
    const appState = useSelector(state => state.app);
    
    return(
        <div>
            {appState.error ? <Message negative><Message.Header>{appState.msgError}</Message.Header></Message>: undefined}
            {appState.alert ? <Message warning><Message.Header>{appState.msgAlert}</Message.Header></Message>: undefined}
        </div>
        );
}

export default Header;